/**
 * @packageDocumentation
 * @module f1/string
 */

export interface SearchIndex {
  /**
   * Returns the index if a match is found or -1 if not. If a negative start value is provided the search will between from the end of the string
   *
   * @public
   * @function f1.searchIndex
   * @param search the string to search for
   * @param from the index to start looking
   * @param s a string of a variable
   * @example
   *
   * ```ts
   * f1.searchIndex('a', 2, 'abca') === 3
   * f1.searchIndex('a', -2, 'abca') === 0
   * ```
   */
  (search: string, from: number, s: string): number;
  (search: string, from: number): (s: string) => number;
}

/**
 * @see SearchIndex
 */
export default (search: string, start: number, s: string) => {
  return start < 0 ? s.lastIndexOf(search, -1 * start) : s.indexOf(search, start);
};
